import React, { PropsWithChildren, useContext } from "react";
import styled from "styled-components";

import { Accessibility, ExamContext } from "./context/examContext";

const Styled = styled.div<Accessibility>`
  transition: font-size 0.5s ease;
  font-size: ${(props) => {
    switch (props.fontSize) {
      case "normal":
        return `1.2rem`;
      case "large":
        return `1.6rem`;
      case "xlarge":
        return `2.0rem`;
      case "huge":
        return `2.4rem`;
    }
  }};
`;

/** Used to ensure font size and other accessibility flags are repsected. */
const AccessibilityWrapper = (props: PropsWithChildren) => {
  const [state] = useContext(ExamContext);

  return <Styled {...state.accessibility}>{props.children}</Styled>;
};

export default AccessibilityWrapper;
